<div class="row shadow title-list-02 bg-white rounded" style="min-height: 100px; margin-bottom: 2rem;">
    <div class="col-md-7 pl-5 d-flex align-items-start" style="padding-top: 6px;">
        <h1 class="lblTitle-02">
            {{ 'record-cae-user.lblTitle' | translate }}
        </h1>
    </div>
    <!-- <div class="col-md-2 d-flex align-items-start justify-content-end">
        <mat-form-field appearance="outline" class="search-field" style="min-width: 50px; max-width: 50px;">
            <mat-label>
                {{ 'common.filters.txtCreationDate' | translate }}
            </mat-label>
            <mat-date-range-input [rangePicker]="txtFechaAlta">
                <input matStartDate placeholder="Fecha inicio" [formControl]="f.txtDateInit">
                <input matEndDate placeholder="Fecha fin" [formControl]="f.txtDateEnd" id="txtDateEnd">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="txtFechaAlta"></mat-datepicker-toggle>
            <mat-date-range-picker #txtFechaAlta>
            </mat-date-range-picker>
        </mat-form-field>
    </div>
    <div class="col-md-3 d-flex align-items-start justify-content-end pr-5" style="padding-top: 6px;">


        <button type="button" class="btn btn-primary w-120-px mr-3" (click)="searchInfo()">
            <i class="fas fa-search text-white mr-2"></i>
            {{ 'common.btnSearch' | translate }}
        </button>

        <button type="button" class="btn btn-secondary flex-justif-alig-center w-100-px" (click)="deleteInfo()">
            <i class="fas fa-times mr-1"></i>
            {{ 'common.btnClear' | translate }}
        </button>
    </div> -->
</div>